var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast"},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.notification.text)))]),(_vm.notification.type)?_c('HubIcon',{staticClass:"icon",attrs:{"icon":_vm.toastIcon,"color":"#fff"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }